import React, { Component, Fragment } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { Layout as AppLayout, ConfigProvider } from "antd";
import LangContext, { i18n } from "modules/shared/context/langContext";
import PrivateRoute from "./PrivateRoute";
import Header from "./Header";

import * as authActions from "modules/auth/actions";
import * as uiActions from "modules/ui/actions";
import { antdLocales } from "lib/antdLocale";
import { LANGUAGES, DEFAULT_LANG, storeLang, getStoredLang } from "constants/local_storage";

import Login from "modules/oauth/components/OauthLogin";

import { ListMenu } from "./ListMenu";
import ContentLayout from "./ContentLayout";

const toLang = (lang) => (LANGUAGES.indexOf(lang) !== -1 ? lang : DEFAULT_LANG);

// ให้ screen reader และ browser รู้ภาษาของหน้า (public/index.html ตั้งไว้ "en")
const setDocumentLang = (lang) => {
  document.documentElement.lang = lang;
};

class Layout extends Component {
  // เริ่มด้วยภาษาที่เลือกไว้ล่าสุด: redux ui.langBtn อ่านจาก localStorage ตอนสร้าง store
  state = {
    i18n: i18n[toLang(this.props.langBtn)],
    langBtn: toLang(this.props.langBtn),
    checkSelectLang: "",
    url: "",
  };

  changeLang = (inputLng) => {
    const lang = toLang(inputLng);
    storeLang(lang);
    // เก็บภาษาได้: reload ทั้งหน้า ให้ทุกหน้าโหลดข้อมูลและสร้างข้อความใหม่ในภาษาที่เลือก
    // (สลับในที่เดิมทำให้หน้า remount แต่ store ยังถือ record id เดิม ฟอร์มแก้ไขบางหน้าจึงว่าง)
    if (getStoredLang() === lang) {
      window.location.reload();
      return;
    }
    // เก็บไม่ได้ (เช่น ปิด storage): สลับในที่เดิม
    this.setState({
      i18n: i18n[lang],
      langBtn: lang,
    });
    this.props.changeLanguage(lang);
    setDocumentLang(lang);
  };

  setMsg = (title, msg) => this.props.setFlashMessage(title, msg);

  onRemoveCredentials = () => {
    this.props.removeCredentials();
  };

  componentDidMount() {
    setDocumentLang(this.state.langBtn);
    this.props.loadCredentials();
  }

  render() {
    // ConfigProvider กับ LangContext ครอบทั้งหน้า login และแอป ข้อความของ antd จึงเปลี่ยนตามภาษาที่เลือกทั้งสองหน้า
    return (
      <ConfigProvider locale={antdLocales[this.state.langBtn]}>
        <LangContext.Provider value={this.state.i18n}>
          <Router>
            <Fragment>
              {this.props.done !== true ? (
                <Login auth={this.props.path} />
              ) : (
                <AppLayout>
                  <AppLayout
                    style={{
                      minHeight: `${window.innerHeight}px`,
                    }}
                  >
                    <Header
                      langBtn={this.state.langBtn}
                      changeLang={this.changeLang}
                      checkSelectLang={this.state.checkSelectLang}
                    />
                    <ContentLayout>
                      {ListMenu.map((v, k) => {
                        return (
                          <PrivateRoute
                            key={k}
                            value={v}
                            done={this.props.done}
                            profile={this.props.profile}
                          />
                        );
                      })}
                    </ContentLayout>
                  </AppLayout>
                </AppLayout>
              )}
            </Fragment>
          </Router>
        </LangContext.Provider>
      </ConfigProvider>
    );
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp },
  ui: { flash, langBtn },
}) => ({
  accessToken,
  done,
  profile,
  flash,
  tokenExp,
  langBtn,
});

const mapDispatchToProps = {
  removeCredentials: authActions.removeCredentials,
  loadCredentials: authActions.loadCredentials,
  clearFlashMessage: uiActions.clearFlashMessage,
  setFlashMessage: uiActions.setFlashMessage,
  changeLanguage: uiActions.changeLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
